"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ThemesEnum;
(function (ThemesEnum) {
    ThemesEnum["EDUCATOR"] = "educator";
    ThemesEnum["STUDENT_K_2"] = "student_k_2";
    ThemesEnum["STUDENT_3_5"] = "student_3_5";
    ThemesEnum["STUDENT_6_8"] = "student_6_8";
    ThemesEnum["STUDENT_9_12"] = "student_9_12";
})(ThemesEnum || (ThemesEnum = {}));
exports.default = ThemesEnum;
